import React from 'react';
import PropTypes from 'prop-types';
import DashedButton from 'Components/Button/DashedButton';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import ImageDeleteIcon from 'Components/icons/ImageDeleteIcon';
import { updateNestedFieldSelectorData } from 'Actions/nestedFieldSelectorAction.js';
import ErrorMessage from './ErrorMessage.jsx';
import { connect } from 'react-redux';
import './NestedFieldSelector.scss';

export class NestedFieldSelector extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isPrePopulated: false,
      //acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
    };

    this.handleAddField = this.handleAddField.bind(this);
    this.handleDeleteField = this.handleDeleteField.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.getDropDownWithInputComponent = this.getDropDownWithInputComponent.bind(this);
    this.updateDropDownValue = this.updateDropDownValue.bind(this);
    this.prePopulatedEntries = this.prePopulatedEntries.bind(this);
  }

  componentWillMount() {
    if (!this.state.isPrePopulated && this.props.nestedFieldSelectorData.fieldCount == 0 && this.props.list.length > 0) {
      this.prePopulatedEntries(
        this.props.list,
        this.props.prePopulatedData,
        this.props.nestedFieldSelectorData,
        this.props.inputList,
        this.props.updateNestedFieldSelectorData,
      );

      this.setState({
        isPrePopulated: true,
      });
    }
  }
  componentDidMount() {
   let isErroronPageFlag = false;
    let currentfieldCount = this.props.nestedFieldSelectorData.fieldCount;
    for (let index = 0; this.props.nestedFieldSelectorData.list && index < currentfieldCount; index++) {
      if (this.props.nestedFieldSelectorData.softDeleted.indexOf(index) === -1) {
        this.props.inputList && this.props.inputList.map((inputElement, inputIndex) => {
          let inputValue = this.props.nestedFieldSelectorData[`InputValue_${inputElement.id}_${index}`];
          inputValue = inputValue !== undefined ? `${inputValue}` : null;
          if(inputValue && inputValue >= this.props.disputeAmount){
            this.setState({currentValue : inputValue })
            isErroronPageFlag = true;
            this.props.onDisableNextStep && this.props.onDisableNextStep(true);
            this.props.storeLatestStatus && inputValue && this.props.storeLatestStatus(inputValue);
          }else{
            if(this.props.onDisableNextStep && inputValue && inputValue < this.props.disputeAmount && this.props.nestedFieldSelectorData.softDeleted.length>0){
               this.props.onDisableNextStep(false);
            }
          }
        })
      } else {
        currentfieldCount++;
      }
    }
 
 
      if(this.props.nestedFieldSelectorData.fieldCount === 0){
        this.props.onDisableNextStep && this.props.onDisableNextStep(true);
      }
      if(isErroronPageFlag){
        this.props.onDisableNextStep && this.props.onDisableNextStep(true);
      }
}
  componentWillReceiveProps(nextProps) {
    if (!this.state.isPrePopulated && (this.props.list.length !== nextProps.list.length || this.props.prePopulatedData.length !== nextProps.prePopulatedData.length)) {
      this.prePopulatedEntries(
        nextProps.list,
        nextProps.prePopulatedData,
        nextProps.nestedFieldSelectorData,
        nextProps.inputList,
        nextProps.updateNestedFieldSelectorData,
      );
    }
  }

  prePopulatedEntries(list, prePopulatedData, nestedFieldSelectorData, inputList, updateNestedFieldSelectorData) {
     let cdDrFlag=false;
    if(prePopulatedData.length==2 && prePopulatedData[0].glAccountNumber=='14015'&& prePopulatedData[1].glAccountNumber=='14015'){
      list.push({
        text: '14015: Bank GL/Misc/Offset Ledger',
        value: '14015: Bank GL/Misc/Offset Ledger',
        appearDefault: false
      })
      cdDrFlag=true;
    }
    
    let listClone = [...list];
    // Pre-populate the default fields which are selected/updated in last API call.
if(cdDrFlag){
 
    prePopulatedData.forEach((prePopulatedDataItem) => {
    const name = `${prePopulatedDataItem.glAccountNumber}: ${prePopulatedDataItem.ledger}`;
    const updateIndex = listClone.findIndex((listItem) => listItem.value === name && listItem.appearDefault===false )
    listClone[updateIndex] = {
      ...listClone[updateIndex],
      defaultValues: {
        v1: prePopulatedDataItem.type.toLowerCase() === 'debit' ? isNaN(prePopulatedDataItem.amount.amount) ? prePopulatedDataItem.amount.amount : (Math.round(prePopulatedDataItem.amount.amount * 100) / 100).toFixed(2) : undefined,
        v2: prePopulatedDataItem.type.toLowerCase() === 'credit' ? isNaN(prePopulatedDataItem.amount.amount) ? prePopulatedDataItem.amount.amount : (Math.round(prePopulatedDataItem.amount.amount * 100) / 100).toFixed(2) : undefined,
      },
      appearDefault: true,
    };
     
  });
}
else{
    prePopulatedData.forEach((prePopulatedDataItem) => {
      const name = `${prePopulatedDataItem.glAccountNumber}: ${prePopulatedDataItem.ledger}`;
      const updateIndex = listClone.findIndex((listItem) => listItem.value === name);
      listClone[updateIndex] = {
        ...listClone[updateIndex],
        defaultValues: {
          v1: prePopulatedDataItem.type.toLowerCase() === 'debit' ? isNaN(prePopulatedDataItem.amount.amount) ? prePopulatedDataItem.amount.amount : (Math.round(prePopulatedDataItem.amount.amount * 100) / 100).toFixed(2) : undefined,
          v2: prePopulatedDataItem.type.toLowerCase() === 'credit' ? isNaN(prePopulatedDataItem.amount.amount) ? prePopulatedDataItem.amount.amount : (Math.round(prePopulatedDataItem.amount.amount * 100) / 100).toFixed(2) : undefined,
        },
        appearDefault: true,
      };
      
    });
  }


    listClone = listClone.map((listItem) => ({ lockedBy: -1, ...listItem }));
    let defaultFieldCount = nestedFieldSelectorData.fieldCount;

    listClone && listClone.forEach((listItem) => {
      if (listItem.appearDefault) {
        if (listItem.value.includes('1100') || listItem.value.includes('14015') || listItem.value.includes('14100')) {
          listItem.lockedBy = -1;
        }
        this.updateDropDownValue(listClone, defaultFieldCount, listItem);
        defaultFieldCount++;
      }
    });
    updateNestedFieldSelectorData({
      ...nestedFieldSelectorData,
      list: listClone,
      inputList,
      prePopulatedData: prePopulatedData,
      fieldCount: defaultFieldCount,
      currencyCode: this.props.bindData[this.props.inputList[0].postLabelKey],

    });
  }

  prepareListInput(list, id) {
    const uniqueList = [...new Map(list.map((l) => [l.value, l])).values()];
    let dropDownList = [];
    let acqirerCode = sessionStorage.getItem("caseAcquirerCode") ;
    const mexicoAcquirer = ['MXI','MXP']
    let acqCode = (mexicoAcquirer.includes(acqirerCode)? "GPN" : acqirerCode );
    uniqueList.map((listItem) => {
      if (this.checkOffsetLedger(acqCode, listItem, id)) {
        dropDownList = dropDownList.concat({ value: listItem.value, text: listItem.text });
      } else if (listItem.value.includes('1100') || listItem.value.includes('14015') || listItem.value.includes('14205') || listItem.value.includes('14100')) {
        listItem.lockedBy = -1;
        dropDownList = dropDownList.concat({ value: listItem.value, text: listItem.text });
      }
    });
    return dropDownList;
  }
  
  checkOffsetLedger(acqCode, listItem, id) {
    switch (acqCode) {
      case "GPN":
        return (listItem.lockedBy === -1 || listItem.lockedBy === id) && (!listItem.value.includes('1100'))
      case "HPY":
        return (listItem.lockedBy === -1 || listItem.lockedBy === id) && (!listItem.value.includes('14015'))
      case "EMD":
      case "EMI":
        return (listItem.lockedBy === -1 || listItem.lockedBy === id) && (!listItem.value.includes('14205'))
      case "GPE":
      case "GPX":
        return (listItem.lockedBy === -1 || listItem.lockedBy === id) && (!listItem.value.includes('14100'))
      default:
        return false
    }
  }
  
  getDropDownWithInputComponent(list, id, displayOrder) {
    const dataList = this.prepareListInput(list, id);
    const selectedDropdownValue = dataList.find((listitem) => listitem.value === this.props.nestedFieldSelectorData[`DropDownValue_${id}`]);

    var isDisabled =false;
    return (
      <React.Fragment>
      <div key={id} className={'field-selector-component'} >
        <SelectInput
          dataList={dataList}
          promptText={'Select    '}
          wrapperClass="select-menu__form reports"
          extraClass={'option-box field-selector-component-input '}
          optionTextWrapCssClass={'field-selector-option-text-wrap'}
          selectClass={{ width: '385px' }}
          handleSelection={this.handleOnChange('DropDownValue', id)}
          selectedItem={selectedDropdownValue}
          label={displayOrder === 1 ? this.props.title : ''}
          addNegativeMargin
          isDisabled={isDisabled}
        />
        {
          this.props.inputType !== 'WPI' && this.props.inputList.map((inputElement, inputIndex) => {
            let inputValue = this.props.nestedFieldSelectorData[`InputValue_${inputElement.id}_${id}`];
            inputValue = inputValue !== undefined ? `${inputValue}` : '';
            const inputLable = displayOrder === 1 ? this.props.bindData[inputElement.postLabelKey] ? `${inputElement.label} (${this.props.bindData[inputElement.postLabelKey]})` : `${inputElement.label}` : '';
            const markCurrentFieldRed = inputElement.inputType === "number" && inputValue && inputValue >= this.props.disputeAmount;
            return (<TextInput
              key={inputIndex}
              name={inputElement.label}
              extraClass={markCurrentFieldRed ? 'field-selector-component-input mark-red' :'field-selector-component-input'}
              label={inputLable}
              hideLabel={displayOrder !== 1}
              width={inputElement.label == 'Internal Notes' ? '310px' : '120px'}
              type={inputElement.inputType}
              onChange={this.handleOnChange(`InputValue_${inputElement.id}`, id)}
              value={inputValue < 0 ? 0 : inputValue}
              disable={selectedDropdownValue === undefined ? true : Boolean(this.props.nestedFieldSelectorData[`InputValue_${inputElement.disableWhenId}_${id}`])}
              placeholder=""
              isWidthFixRequired
              extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }}
            />);
          })
        }

        <div
          key={id}
          className={displayOrder === 1 ? 'field-selector-component-delete' : 'field-selector-component-delete-without-label'}
          role="button"
          onClick={this.handleDeleteField(id)}
          style={displayOrder === 1 ? { paddingTop: 30 } : { paddingTop: 8 }}
        >
          <ImageDeleteIcon />
        </div>
      </div>
      {this.props.inputType !== 'WPI' && this.props.inputList.map((inputElement, inputIndex) => {
        let inputValue = this.props.nestedFieldSelectorData[`InputValue_${inputElement.id}_${id}`];
        inputValue = inputValue !== undefined ? `${inputValue}` : null;
        return <>{inputElement.inputType === "number" && inputValue && inputValue >= this.props.disputeAmount ? <div className="conditional-block">
          <ErrorMessage key={id} disputeAmount={this.props.disputeAmount} />
        </div> : null}</>
      })}
      </React.Fragment>
    );
  }

  updateDropDownValue(currentList, id, list) {
    let value=list.value?list.value:list;
    // Assign lock to the list element, so it won't not appear in next drop down
    const listClone = [...currentList];
    currentList.forEach((listItem, index) => {
      if (listItem.lockedBy === id) {
        // Unlock existing items, to make sure one-to-one mapping
        listClone[index].lockedBy = -1;
      }
    });
   const elementIndex= list.value? currentList.findIndex((listItem) => 
    listItem.value === list.value && listItem.defaultValues.v1 === list.defaultValues.v1 &&
    listItem.defaultValues.v2 === list.defaultValues.v2
    ):currentList.findIndex((listItem) => listItem.value === value);
    if (listClone[elementIndex]) { listClone[elementIndex].lockedBy = id; }

    // Set default threshold value for particular input fields.
    const elementValues = {};
    this.props.inputList.forEach((eachList) => {
      elementValues[`InputValue_${eachList.id}_${id}`] = this.props.nestedFieldSelectorData.prevPopulated !== undefined &&  ((this.props.nestedFieldSelectorData.prevPopulated.value === this.props.nestedFieldSelectorData[`DropDownValue_${id}`])) ? undefined : (listClone[elementIndex] && listClone[elementIndex].defaultValues ? listClone[elementIndex].defaultValues[eachList.id] : this.props.nestedFieldSelectorData[`InputValue_${eachList.id}_${id}`]);
    });
      this.props.nestedFieldSelectorData && this.props.nestedFieldSelectorData.prePopulatedData && this.props.nestedFieldSelectorData.prePopulatedData.map((existingValues)=>{
        this.props.inputList.forEach((eachList) => {
          elementValues[`InputValue_${eachList.id}_${id}`] = undefined;
        });
    });
    
    this.props.updateNestedFieldSelectorData({
     
      ...this.props.nestedFieldSelectorData,
      [`DropDownValue_${id}`]: value,
      ...elementValues,
      list: listClone,
      currencyCode: this.props.bindData[this.props.inputList[0].postLabelKey],
    });
  }

  handleOnChange = (type, id) => (event) => {
    if(event.target && event.target.value<0){
      event.target.value = event.target.value * -1;
    }
    const elementValues = {};
    this.props.nestedFieldSelectorData && this.props.nestedFieldSelectorData.prePopulatedData && this.props.nestedFieldSelectorData.prePopulatedData.map((existingValues) => {
      const name = `${existingValues.glAccountNumber}: ${existingValues.ledger}`;
      if (name === event) {
        this.props.inputList.forEach((eachList) => {
          elementValues[`InputValue_${eachList.id}_${id}`] = undefined;
        });
      }
    });
    type === 'DropDownValue' ? this.updateDropDownValue(this.props.nestedFieldSelectorData.list, id, event) : this.props.updateNestedFieldSelectorData({
      ...this.props.nestedFieldSelectorData,
      [`${type}_${id}`]: event.target.value,
    });
    
   if(event.target && event.target.value >= this.props.disputeAmount){
    this.setState({
      currentValue : event.target.value,
    },()=>{
      this.props.storeLatestStatus && this.props.storeLatestStatus(this.state.currentValue);
      this.props.onDisableNextStep && this.props.onDisableNextStep(true);
    })
   }
   
  }

  handleAddField() {
    // Check to add not more fields than actual size received from API.
    if (this.props.nestedFieldSelectorData.fieldCount < this.props.nestedFieldSelectorData.list.length) {
      this.props.updateNestedFieldSelectorData({
        ...this.props.nestedFieldSelectorData,
        fieldCount: this.props.nestedFieldSelectorData.fieldCount + 1,
      });
    }
  }

  handleDeleteField = (id) => () => {
    // Assign lock to the list element, so it won't not appear in next drop down
    const listClone = [...this.props.nestedFieldSelectorData.list];
    let isDuplicate = this.props.nestedFieldSelectorData.list.filter((listItem) => (listItem.value === this.props.nestedFieldSelectorData[`DropDownValue_${id}`]) || listItem.appearDefault);
    const elementIndex = this.props.nestedFieldSelectorData.list.findIndex((listItem) => listItem.value === this.props.nestedFieldSelectorData[`DropDownValue_${id}`]);
    if (elementIndex !== -1) {
        listClone[elementIndex].lockedBy = -1;
    }
    const elementValues = {};
    this.props.inputList.forEach((eachList) => {
      elementValues[`InputValue_${eachList.id}_${id}`] = '';
    });
    this.props.storeLatestStatus && this.props.storeLatestStatus(this.state.currentValue);
    this.props.updateNestedFieldSelectorData({
      ...this.props.nestedFieldSelectorData,
      fieldCount: this.props.nestedFieldSelectorData.fieldCount - 1,
      softDeleted: this.props.nestedFieldSelectorData.softDeleted.concat(id),
      rawDataDeletedId: id,
      prevPopulated: isDuplicate,
      list: listClone,
      ...elementValues,
    });
    
  };

  render() {
    let currentfieldCount = this.props.nestedFieldSelectorData.fieldCount;
    let dynamo = [];
    let displayOrder = 0;
    for (let index = 0; this.props.nestedFieldSelectorData.list && index < currentfieldCount; index++) {
      localStorage.setItem('newIndex', index);    
      if (this.props.nestedFieldSelectorData.softDeleted.indexOf(index) === -1) {
        displayOrder += 1;
        dynamo = dynamo.concat(this.getDropDownWithInputComponent(this.props.nestedFieldSelectorData.list, index, displayOrder));
      } else {
        currentfieldCount++;
      }
    }
    return (<div key={currentfieldCount} className="field-selector" style={{ width: '97%' }}>
      {dynamo.map((line) => line)}
      {this.props.nestedFieldSelectorData.fieldCount !== this.props.list.length && <DashedButton
        action={this.handleAddField}
      >
        <span>+ Add More</span>
      </DashedButton>}

    </div >);
  }
}

NestedFieldSelector.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  size: PropTypes.number,
  identifier: PropTypes.string.isRequired,
  inputList: PropTypes.array.isRequired,
  inputType: PropTypes.string,
  bindData: PropTypes.object,
  prePopulatedData: PropTypes.array,
  nestedFieldSelectorData: PropTypes.object,
  updateNestedFieldSelectorData: PropTypes.func,
};

NestedFieldSelector.defaultProps = {
  title: 'Default title',
  size: 12,
  list: [],
  bindData: {},
  prePopulatedData: [],
};

const mapStateToProps = (state) => ({
  nestedFieldSelectorData: state.nestedFieldSelectorData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateNestedFieldSelectorData: (dataToBeUpdated) => {
      dispatch(updateNestedFieldSelectorData(dataToBeUpdated));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NestedFieldSelector);
